var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 626,
    height: 626,
    viewBox: "0 0 626 626",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2584_12959)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 312.689,
    cy: 312.689,
    r: 283.189,
    stroke: "url(#paint0_linear_2584_12959)",
    strokeWidth: 11
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 313.203,
    cy: 313.202,
    r: 281.049,
    stroke: "url(#paint1_linear_2584_12959)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2584_12959",
    x: 0,
    y: 0,
    width: 625.379,
    height: 625.378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_2584_12959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2584_12959",
    x1: 24,
    y1: 24,
    x2: 318.649,
    y2: 720.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#943E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#1564DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#943E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1564DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2584_12959",
    x1: 30.1543,
    y1: 30.1532,
    x2: 319.046,
    y2: 713.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#943E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#1564DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FCF2FF",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#943E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1564DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/ellipse.5db48bd4eae875ed16e1cb26e103b367.svg";
export { ForwardRef as ReactComponent };